import React, { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Flex } from 'antd';

const Products = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  // Redirect to /user/products if needed
  useEffect(() => {
    const currentPath = pathname.replace(/\/$/, '');
    if (currentPath === '/products') {
      navigate('/user/products', { replace: true });
    }
  }, [pathname, navigate]);

  return (
    <Flex className="h-full">
      <div className="p-6 flex-1 overflow-auto w-full">
        <Outlet />
      </div>
    </Flex>
  );
};

export default Products;

